var ranges = {
	hrs: { start: 0, end: 2 },
	min: { start: 3, end: 5 },
	mode: { start: 6, end: 8 },
}

export default ranges
